// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';
import { toggleCreateDialog } from 'store/reducers/projectSettingsSlice';
import { Dialog, EmptyState, FooterButton } from '@tls/treact-ui';

export default function NoLicenseDialogContent() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onClose = useCallback(() => {
    dispatch(toggleCreateDialog());
  }, [dispatch]);

  return (
    <>
      <Dialog.DialogContent>
        <EmptyState
          iconType={'error'}
          label={t('projects.create.noLicense')}
          data-testid='projects-create-no-license-state'
        />
      </Dialog.DialogContent>
      <Dialog.Footer
        right={[
          <FooterButton
            key='cancel'
            label={t('cancel')}
            onClick={onClose}
            variant='secondary'
            data-testid='projects-create-no-license-cancel-button'
          />,
        ]}
      />
    </>
  );
}
